import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getGeneralType = async (type: string, isActive = true) => {
  try {
    return await get<ApiResponse<any[]>>("/general-type", { type, isActive }).then((res) => {
      if (res?.success === true) {
        return res;
      }

      return null;
    });
  }
  catch (e: any) {
    HandleApiError(e);
    return null;
  }
};
